import "./bootstrap";
import "./plugins";
import Vue from "vue";
import Vuex from "vuex";
import vuexI18n from "vuex-i18n";
import "./core/coreApp";
import "./app/AppComponents";
import "./app/DemoComponent";
import "./app/SuperAdminComponents";
import "./app/ClientComponents";
import "./app/ScreeningComponent";
import Element from "element-ui";

// import "../sass/formbuilder/main.scss";

// vue tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

import moment from "moment";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("MM/DD/YYYY");
  }
});
import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

import { Plugin } from 'vue-fragment';
Vue.use(Plugin);
// import Vuetify from '../src/plugins/vuetify' // path to vuetify export
// import 'vuetify/dist/vuetify.min.css'
// Vue.use(Vuetify)

window.Vue = Vue;

import VueHtml2pdf from "vue-html2pdf";
Vue.use(VueHtml2pdf);

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

import VueChatScroll from "vue-chat-scroll";
Vue.use(VueChatScroll);
/**
 * vuex
 */

Vue.use(Vuex);

import locale from "element-ui/lib/locale/lang/en";
Vue.use(Element, { locale });

import storeData from "./store/Index";
// import storeData from "./store/Index";
const store = new Vuex.Store(storeData);

// forceupdate component reload and re-render
// Vue.forceUpdate();

/**
 * localization
 * $t('key') or this.$('key')
 * link: https://github.com/dkfbasel/vuex-i18n
 * */

Vue.use(vuexI18n.plugin, store);

// add translations directly to the application
let language = JSON.parse(window.localStorage.getItem("app-languages"));
let key = window.localStorage.getItem("app-language");
Vue.i18n.add(key, language);
// set the start locale to use
Vue.i18n.set(key);

Vue.prototype.$log = console.info;

/*------ localization end ------*/

import firebaseHelper from "./firebase.js";

const app = new Vue({
  store,
  el: "#app",
});

global.app = app;
export default app;
